<div mat-dialog-content>

  <h2>新規口座の作成を行います</h2>

  <div style="margin-top: 1em; margin-bottom: 1em;">
    <h4>①出資者を選択してください</h4>
    <br>
    <div style="">
      <app-search-user-list [isDialogMode]="true" (selected)="onUserSelect($event)"></app-search-user-list>
    </div>
  </div>

  <div *ngIf="user">
    <h4>②口座に必要な情報を入力してください</h4>
    <table>
      <tr><th>項目</th><th>値</th><th>入力エラー・備考など</th></tr>
      <tr>
        <th>login</th><td>{{report.login_user_id}}</td><td></td>
      </tr>
      <tr>
        <th>name</th><td>{{report.user_name}}</td><td></td>
      </tr>
      <tr>
        <th>mail</th><td>{{user ? user.mail: ''}}</td><td></td>
      </tr>
      <tr>
        <th>POOL</th>
        <td>
          <mat-select (selectionChange)="onPoolSelect($event)">
            <mat-option *ngFor="let obj of PoolTypeMap" [value]="obj">{{ obj.pool }}</mat-option>
          </mat-select>
        </td>
        <td><span [ngClass]="{'error': !isPoolValid}">選択必須</span></td>
      </tr>
      <tr>
        <th>通貨</th>
        <td>
          <mat-select [(ngModel)]="report.cur">
            <mat-option *ngFor="let name of CurrencyTypes" [value]="name">{{ name }}</mat-option>
          </mat-select>
        </td>
        <td><span [ngClass]="{'error': !isCurValid}">選択必須</span></td>
      </tr>
      <tr>
        <th>入金額（{{report.cur ?? '先に通貨を選択'}}）</th>
        <td><app-decimal-input [(ngModel)]="report.nyukin" [positiveOnly]="true"></app-decimal-input></td>
        <td><span [ngClass]="{'error': !isNyukinValid}">入力必須</span></td>
      </tr>
      <tr>
        <th>成功報酬料率 (%)</th>
        <td><app-decimal-input [asPercent]="true" [scale]="3" [(ngModel)]="report.hdc" [positiveOnly]="true"></app-decimal-input></td>
        <td><span [ngClass]="{'error': !isHdcValid}">必ず０％以上の数値を入力してください</span></td>
      </tr>

      <tr>
        <th>管理手数料率 (%)</th>
        <td><app-decimal-input [asPercent]="true" [scale]="3" [(ngModel)]="report.monthly_management_fee" [positiveOnly]="true"></app-decimal-input></td>
        <td>未入力の場合は０％扱いになります</td>
      </tr>

      <tr>
        <th>運用開始・拘束期間・終了日</th>
        <td colspan="2">
          <input type="date" [(ngModel)]="report.enroll" (blur)="calcChg()"> 開始
          <input type="number" [(ngModel)]="report.res_b" (blur)="calcChg()" style="margin-left: 1em; width: 4em;"> ヶ月
          <input type="date" [(ngModel)]="report.chg" style="margin-left: 1em;" readonly> まで拘束
        </td>
      </tr>

      <tr>
        <th>JACは共同口座</th>
        <td><input type="text" [(ngModel)]="report.flg"></td>
        <td><span [ngClass]="{'error': !isFlgValid}">「JAC」（半角）のみ入力可能</span></td>
      </tr>

      <tr>
        <th><span [ngClass]="{'error': !isCmmValid}">共同名義者名（JACには必須）</span></th>
        <td colspan="2"><input type="text" [(ngModel)]="report.cmm" style="width: 96%;"></td>
      </tr>

      <tr>
        <th>この口座に関する備考</th>
        <td colspan="2"><textarea [(ngModel)]="report.note" style="width: 98%;" rows="3"></textarea></td>
      </tr>

    </table>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="saving">
      キャンセル
    </button>
    <button mat-raised-button color="primary"
            (click)="onSave()"
            [disabled]="saving || !isValid">
      {{ saving ? '保存中...' : (isRebuildMode ? '口座を追加して当月以降の履歴を全更新' : '保存') }}
    </button>

</div>
